import React from "react";
import {
  Info,
  HelpCircle,
  XCircle,
  CheckCircle2,
  LifeBuoy,
} from "lucide-react";

function IadeIptalPolitikasi() {
  return (
    <div className="max-w-6xl mx-auto p-6 bg-gray-50 min-h-screen">
      <div className="text-center mb-12">
        <div className="inline-flex items-center justify-center gap-3 mb-6">
          <div className="bg-purple-500 p-3 rounded-full shadow-lg">
            <Info className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900 uppercase">
            İptal ve İade Politikası
          </h1>
        </div>
      </div>

      <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100">
        <div className="md:flex">
          <div className="bg-purple-500 p-12 text-white md:w-1/3 flex flex-col justify-center">
            <XCircle className="text-white w-16 h-16 mb-6 opacity-80" />
            <h2 className="text-3xl font-bold mb-4">Neden İade Yapılamaz?</h2>
            <p className="text-rose-100 leading-relaxed">
              Dijital eğitim ürünleri "anında tüketilen" içerikler olduğu için
              fiziksel ürünler gibi iade sürecine tabi değildir.
            </p>
          </div>

          <div className="p-12 md:w-2/3 space-y-8">
            <div className="flex gap-4">
              <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0" />
              <div>
                <h4 className="font-bold text-gray-900">
                  Satın Alım Öncesi Deneyim
                </h4>
                <p className="text-gray-600 text-sm">
                  Tanıtım videolarını izleyerek sistemin size uygunluğunu
                  kontrol etmeniz önerilir.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <LifeBuoy className="w-6 h-6 text-blue-500 flex-shrink-0" />
              <div>
                <h4 className="font-bold text-gray-900">
                  Teknik Destek Garantisi
                </h4>
                <p className="text-gray-600 text-sm">
                  İçeriğe erişememe gibi teknik sorunlarda ekibimiz 24 saat
                  içinde çözüm sunar.
                </p>
              </div>
            </div>

            <div className="bg-gray-50 p-6 rounded-2xl border border-dashed border-gray-300">
              <p className="text-sm text-gray-500 italic">
                Sorularınız için:{" "}
                <span className="font-bold text-purple-500">
                  classroom.destek@gmail.com
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IadeIptalPolitikasi;
